import { request } from "./http";

export const appointmentsPerDay = (params?: { start?: string; end?: string; employee_id?: number; breakdown?: boolean }) => {
  const q = new URLSearchParams();
  if (params?.start) q.set("start", params.start);
  if (params?.end) q.set("end", params.end);
  if (params?.employee_id) q.set("employee_id", String(params.employee_id));
  if (params?.breakdown) q.set("breakdown", "1");
  const qs = q.toString();
  return request<any[]>(`/api/metrics/appointments-per-day${qs ? `?${qs}` : ""}`);
};

export const plansAndPayments = (params?: { start?: string; end?: string }) => {
  const q = new URLSearchParams();
  if (params?.start) q.set("start", params.start);
  if (params?.end) q.set("end", params.end);
  const qs = q.toString();
  return request<{
    active_plans: { count: number; total_cents: number };
    late_payments: { count: number; total_cents: number };
    paid_payments: { count: number; total_cents: number };
  }>(`/api/metrics/plans-payments${qs ? `?${qs}` : ""}`);
};
